import React, { forwardRef, ComponentPropsWithoutRef } from "react";

import { StyledButton } from "./Styles";

export const Trigger = forwardRef<
  HTMLButtonElement,
  ComponentPropsWithoutRef<"button">
>(({ children, type = "button", ...rest }, ref) => {
  return (
    <StyledButton ref={ref} role="button" type={type} {...rest}>
      {children}
    </StyledButton>
  );
});

Trigger.displayName = "Trigger";
